import React, { useState } from 'react';
import Services from '../../api/service'
import Link from 'shared/SlashLink';

const TABS = [
    { key: 'construction', label: 'Construction Projects', sub: 'Technology design for new builds & renovations' },
    { key: 'business', label: 'Business IT', sub: 'Day-to-day technology for growing companies' },
]

const ServiceSection = (props) => {
    const [active, setActive] = useState('construction')

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const visible = Services.filter(s => s.category === active)
    const activeTab = TABS.find(t => t.key === active)

    return (
        <section className="service_section section_space xb-hidden pb-0">
            <div className="container">
                <div className="heading_block text-center">
                    <div className="heading_focus_text">
                        Our
                        <span className="badge bg-secondary text-white">Services</span>
                    </div>
                    <h2 className="heading_text mb-3">
                        Two tracks. One partner.
                    </h2>
                    <p className="heading_description mb-0">
                        {activeTab.sub}
                    </p>
                </div>

                <ul className="nav justify-content-center mb-4" role="tablist" style={{ gap: '12px' }}>
                    {TABS.map(tab => (
                        <li className="nav-item" key={tab.key}>
                            <button
                                type="button"
                                onClick={() => setActive(tab.key)}
                                className="btn"
                                style={{
                                    padding: '10px 26px',
                                    background: active === tab.key ? '#0a1f44' : 'transparent',
                                    color: active === tab.key ? '#fff' : '#0a1f44',
                                    border: '1px solid #0a1f44',
                                    borderRadius: '6px',
                                    fontWeight: 600,
                                }}
                                aria-pressed={active === tab.key}
                            >
                                <span className="btn_label" data-text={tab.label}>{tab.label}</span>
                            </button>
                        </li>
                    ))}
                </ul>

                <div className="row">
                    {visible.map((service, srv) => {
                        const to = service.link || `/service-single/${service.slug}`;
                        return (
                        <div className={`${service.col} mt-30`} key={`${active}-${srv}`}>
                            <div className="service_block">
                                <div className="service_image">
                                    <img src={service.sImg} alt={`BUILDLAB - ${service.title}`} />
                                </div>
                                <div className="service_content">
                                    <h3 className="service_title">
                                        <Link onClick={ClickHandler} to={to}>{service.title}</Link>
                                    </h3>
                                    <div className="links_wrapper">
                                        <ul className="category_btns_group unordered_list">
                                            <li><Link onClick={ClickHandler} to={to}>{service.thumb1}</Link></li>
                                            <li><Link onClick={ClickHandler} to={to}>{service.thumb2}</Link></li>
                                        </ul>
                                        <Link onClick={ClickHandler} to={to} className="icon_block">
                                            <i className="fa-regular fa-arrow-up-right" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        );
                    })}
                </div>

                <div className="btns_group pb-0">
                    <Link onClick={ClickHandler} className="btn btn-outline-light" to="/service">
                        <span className="btn_label" data-text="More Services">More Services</span>
                        <span className="btn_icon">
                            <i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i>
                        </span>
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default ServiceSection;
